import { Component, EventEmitter, inject, Output } from '@angular/core';
import { MultiSectionFormPreviewService } from '../multi-section-form-preview.service';


@Component({
    selector: 'app-footer-buttons',
    templateUrl: './footer-buttons.component.html',
    styleUrls: ['./footer-buttons.component.css'],
    standalone: true,
    imports: [],
})
export class FooterButtonsComponent {
  @Output() modalClose: EventEmitter<string> = new EventEmitter();
  public msfps = inject(MultiSectionFormPreviewService);

  ngOnInit() {
    this.msfps.modalHelper$.asObservable().subscribe((helperVal) => {
      if (helperVal === 'SUBMIT_SURVEY_OK') {
        this.msfps.submit();
      }
    });

    // Check if form has linked form for review submission (only for supplier users)
    if (this.msfps.mode === 'supplierEdit') {
      this.msfps.checkHasLinkedForm();
    }
  }

  close(triggeredBy: string) {
    this.modalClose.emit(triggeredBy);
  }
}
